export default __webpack_public_path__ + "static/media/program_intro_7.c495b930.png";